import { NgForOf, NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-skeleton',
    templateUrl: 'skeleton.component.html',
    styleUrls: [],
    imports: [NgForOf, NgTemplateOutlet]
})
export class SkeletonComponent {
  @Input() type: 'search' | 'map' | 'default' = 'default';

  @ViewChild('placeholder', { static: true })
  placeholderTemplate!: TemplateRef<unknown>;
  @ViewChild('searchPlaceholder', { static: true })
  searchPlaceholder!: TemplateRef<unknown>;
  @ViewChild('mapPlaceholder', { static: true })
  mapPlacehoder!: TemplateRef<unknown>;

  getTemplate(): TemplateRef<unknown> {
    switch (this.type) {
      case 'search':
        return this.searchPlaceholder;
      case 'map':
        return this.mapPlacehoder;
      default:
        return this.placeholderTemplate;
    }
  }
}
